import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Stack,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";

export const ContactPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();

  const handleTop = () => {
    navigate("/");
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "orange.100",
        p: 2,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* ヘッダー */}
      <Box sx={{ mb: 2 }}>
        <Typography
          variant={isMobile ? "h5" : "h4"}
          component="h1"
          align="center"
          sx={{ fontWeight: "bold", color: "primary.main" }}
        >
          お問い合わせ
        </Typography>
      </Box>

      {/* メインコンテンツ */}
      <Card
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          p: { xs: 2, md: 4 },
        }}
      >
        <CardContent sx={{ textAlign: "center" }}>
          <Stack spacing={3}>
            {/* 説明文 */}
            <Typography
              variant={isMobile ? "body1" : "h6"}
              sx={{ lineHeight: 1.8, mb: 2 }}
            >
              お問い合わせはＥメールで承ります。
            </Typography>

            <Typography
              variant={isMobile ? "body2" : "body1"}
              sx={{ lineHeight: 1.8, mb: 2 }}
            >
              返答までに少々お時間をいただくこと、また検査データ閲覧システム以外のご質問にはお答えできませんので、あらかじめご承知ください。
            </Typography>

            <Typography
              variant={isMobile ? "body2" : "body1"}
              sx={{ lineHeight: 1.8, mb: 3 }}
            >
              なお、メールの件名は「検査データ―問い合わせ」としてください。
            </Typography>

            {/* メールアドレス */}
            <Box
              sx={{
                bgcolor: "grey.100",
                p: 2,
                borderRadius: 1,
                border: "1px solid",
                borderColor: "grey.300",
              }}
            >
              <Typography
                variant={isMobile ? "body1" : "h6"}
                sx={{ fontWeight: "bold", mb: 1 }}
              >
                メールアドレス
              </Typography>
              <Typography
                variant={isMobile ? "body2" : "body1"}
                sx={{
                  fontFamily: "monospace",
                  fontSize: isMobile ? "0.9rem" : "1rem",
                  wordBreak: "break-all",
                }}
              >
                fma-nt@chic.ocn.ne.jp
              </Typography>
            </Box>
          </Stack>
        </CardContent>
      </Card>

      {/* ログイン画面へ戻るボタン */}
      <Box sx={{ mt: 2, textAlign: "center" }}>
        <Button
          variant="contained"
          color="success"
          startIcon={<HomeIcon />}
          onClick={handleTop}
          size="small"
        >
          ログイン画面へ戻る
        </Button>
      </Box>
    </Box>
  );
};
